<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <ng-container *ngFor="let policy of policyDetails">
    <ng-container *ngIf="policy?.policynumber.policyNumber === policyId">
  <header class="margin-bottom mb16">
    <ng-container *ngIf="isAcmic; else maCheckPayment">
    <div class="type-title">
      <h1 class="title">
          {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
      </h1>
      <div class="sub-title">
        <ng-container *ngIf="policy?.policyType==='AUTO' || policy?.policyType==='HOME'">Personal</ng-container>
        <span [ngClass]="{'text-lower-case':policy?.policyType==='AUTO' || policy?.policyType==='HOME'}">
          {{ ( policy?.policyType ==='HOME') ? "property" : policy?.policyType | translate | replaceUnderscoreWithSpace }} - <strong>{{ policy?.policynumber.policyNumber }}</strong>
        </span>
      </div>
    </div>
  </ng-container>
  <ng-template #maCheckPayment>
    <div class="type-title">
      <h1 class="title dm-sans-medium">
          {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
      </h1>
      <div class="sub-title">
        <img 
          src="{{policy?.displayType?.icon}}" 
          width="40" height="40" class="mr-2" 
          alt="{{policy?.policyType?.toLowerCase()}} icon" 
        />
        <!-- <ng-container *ngIf="policy?.policyType === 'HOME'; else nonHome">
          <img src="./assets/img/images/icon-home.svg" width="40" height="40" class="mr-2" alt="home icon" />
        </ng-container>
        <ng-template #nonHome>
          <ng-container *ngIf="policy?.policyType === 'UMBRELLA'; else carIcon">
            <img src="./assets/img/images/icon-umbrella.svg" width="40" height="40" class="mr-2" alt="umbrella icon" />
          </ng-container>
          <ng-template #carIcon>
            <img src="./assets/img/images/icon-car.svg" width="40" height="40" class="mr-2" alt="car icon" />
          </ng-template>            
        </ng-template>   -->

        {{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}</div>
    </div>
  </ng-template>
  </header>

  <section class="row details-content no-padding new_payment no-margin">
    <div class="col col1">
      <ng-container *ngIf="policy.billingDetails">
        <app-new-payment-form [inputs]="inputs" [policy]="policy" [billingDetails]="policy.billingDetails[0]" [isEFT]="policy?.policyFlags?.isEft"></app-new-payment-form>  
      </ng-container>
      <div class="margin-top mt16 d-table w-100" *ngIf="(policy.billingDetails[0] | json) === ({} | json)">
        <div class="no-payment-svg d-table-cell padding pr16">
          <svg-check-icon-svg></svg-check-icon-svg> 
        </div>
        <div class="green-color font-medium d-table-cell align-middle">
          {{ 'NO_PAYMENTS' | translate }}
        </div>
      </div>
    </div>
    <div class="col col2">
      <app-billing-sidebar [policy]="policy"></app-billing-sidebar>
    </div>
  </section>
</ng-container>
